import React from "react";
import {FC} from "react";
import DtoTable from "../../components/dto-table/dto-table";
import DeliveryOrderListModel from "../../models/dto/delivery-order-model";
import useSafeState from "../../utils/safe-state";
import {Modal, Breadcrumb, Tooltip, Button, message, Popconfirm, InputNumber, Divider} from "antd";
import {Trans} from "@lingui/macro";
import {useAxios} from "../../utils/hooks";
import { AxiosResponse, AxiosError } from 'axios';
import {antdContext} from "../../utils/antdContext";
import { openNotification } from '../../utils/openNotification';

import {
    DeleteTwoTone, EditOutlined
} from "@ant-design/icons/lib";


import {PlusOutlined} from "@ant-design/icons/lib";
import NewDeliveryForm from "../../forms/delivery-form/new-delivery-form";
import Drawer from "../../components/drawer/drawer";
import {UndoOutlined} from "@ant-design/icons";
import ButtonWithIcon from "../../components/buttons/button-with-icon";

const DeliveryOrderListScreen : FC = () => {

    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");
    const [loading, setLoading] = useSafeState(false);
    const [trigger, setTrigger] = useSafeState(false);
    const [viewDeliveryId, setViewDeliveryId] = useSafeState<any>();
    const [isModalVisible, setIsModalVisible] = useSafeState(false);
    const [actRollNumber, setActRollNumber] = useSafeState<any>();
    const [actWeight, setActWeight] = useSafeState<any>();
    
    const newDeliveryDrawer = Drawer(
        {
            title: <Trans>Delivery</Trans>,
            children:
                <NewDeliveryForm/>,
            customClose: () => setTrigger(!trigger)
        }
    );

    const action =  (record: any) => {

            return (
            <>
                <Tooltip  title={<Trans>Take it back</Trans>}>
                    <UndoOutlined className={"ActionButtons"}
                                  style={{color: "#40a9ff"}}
                                  onClick={() => {
                                      setActWeight(record.weight);
                                      setActRollNumber(record.rollNumber);
                                      setIsModalVisible(true);
                                  }
                    }/>
                </Tooltip>
            </>
    )};

    const actions = {
        width: 110,
        render: (text: string, record: any) => action(record),
        title: '',
        fixed: 'right',
        align: 'center'
    };

    const handleDeleteOk = (deleteid: any) => {
        
        if(axiosInstance.current != null) {
            setLoading(true);
            axiosInstance.current.delete("/resource/delivery/deleterecord?deliveryId=" + deleteid, {})
                .then(function (response : AxiosResponse<any>) {
                    setLoading(false);
                    message.success(antdContext('Az adott sor sikeresen törölve lett.'));
                    setTrigger(false);
                    setTrigger(!trigger);
                }).catch(function (error :AxiosError) {
                    let errResp = JSON.parse(JSON.stringify(error.response));
                    let errMessage = errResp.data.message;
                    openNotification('error',errMessage);
                    console.log(error)
                    setLoading(false);
            });
        }
    }

    const handleOk = () => {

        if(axiosInstance.current != null) {
            setLoading(true);
            axiosInstance.current.put("/resource/stock/take-back-from-prod-by-roll-number-and-weight?rollNumber="
                + encodeURIComponent(actRollNumber) + "&weight=" + actWeight,
                {})
                .then(function (response : AxiosResponse<any>) {
                    setTrigger(false);
                    setTrigger(!trigger);
                    setIsModalVisible(false);
                }).catch(function (error :AxiosError) {
                    let errResp = JSON.parse(JSON.stringify(error.response));
                    let errMessage = errResp.data.message;
                    openNotification('error',errMessage);
                    console.log(error)
                    setLoading(false);
                });
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const header = (
        <>

            <Button type={"primary"} onClick={ () => {newDeliveryDrawer.open("", {deliveryId: viewDeliveryId, mode: 'AddNew'});}} style={{ float: 'left' }}>
                <ButtonWithIcon icon={<PlusOutlined />} text={<Trans>Új hozzáadása</Trans>} />
            </Button>
            <Divider type="vertical" style={{ float: 'left', fontSize: 'xxx-large' }} />

        </>
    );

    return (<>
        <>
        
            <Breadcrumb style={{ marginBottom: 10 }}>
                <Breadcrumb.Item><Trans id={'Homepage'}/></Breadcrumb.Item>
                <Breadcrumb.Item><Trans id={'Delivery order list'}></Trans></Breadcrumb.Item>
            </Breadcrumb>
            <Modal title={<Trans>Take it back</Trans>} visible={isModalVisible} onOk={handleOk}
                   onCancel={handleCancel} width={230} okText="Igen" cancelText="Nem">
                <div><Trans>Returned weight (kg)</Trans>:</div>
                <InputNumber value={actWeight} onChange={(value) => setActWeight(value)} min={0} style={{width: "100%"}}/>

            </Modal>
            <DtoTable
                tableHeader={header}
                model={DeliveryOrderListModel}
                action={actions}
                allowRefreshButton={true}
                trigger={trigger}
                pageSize={100}
                scroll={{ x: 1300, y: "65vh" }}
            />
            
            {newDeliveryDrawer.component}
            </>

    </>
)
}
export default DeliveryOrderListScreen;
